class StickyBarInteraction {
    constructor() {
        this.stickyFlavorCards = document.querySelectorAll('.product_sticky_flavor_card');
        this.flavorCards = document.querySelectorAll('.flavor_card');
        this.stickyBubble = document.querySelector('.product_sticky_quantity_bubble');
        this.optionButton = document.querySelector('.subscription-option');
        this.selectDropdown = document.querySelector('.subscription-select');
        this.optionButtons = this.selectDropdown?.querySelectorAll('.option-button');

        this.init();
    }

    init() {
        this.synchronizeFlavors();
        this.addFocusListeners();
        this.addScrollListener();
        this.initSubscriptionDropdown();
    }

    synchronizeFlavors() {
        if (this.stickyFlavorCards.length !== this.flavorCards.length) {
            console.error('Mismatch in the number of flavor cards between the two containers.');
            return;
        }

        this.stickyFlavorCards.forEach((stickyCard, index) => {
            const stickySelect = stickyCard.querySelector('.product_sticky_quantity-select');
            const stickyBubble = stickyCard.querySelector('.product_sticky_quantity_bubble');
            const flavorSelect = this.flavorCards[index].querySelector('.quantity-select');

            if (stickySelect) {
                stickySelect.addEventListener('change', () => {
                    flavorSelect.value = stickySelect.value;
                    stickyBubble.textContent = stickySelect.value;
                    console.log(`Sticky flavor updated: ${stickySelect.value} -> Main flavor set to ${flavorSelect.value}, Bubbles set to ${stickySelect.value}`);
                    flavorSelect.dispatchEvent(new Event('change'));
                });
            }

            flavorSelect.addEventListener('change', () => {
                stickyBubble.textContent = flavorSelect.value;
                console.log(`Main flavor updated: ${flavorSelect.value} -> Sticky bubble set to ${stickyBubble.textContent}`);
            });
        });
    }

    addFocusListeners() {
        this.stickyFlavorCards.forEach((card) => {
            const select = card.querySelector('.product_sticky_quantity-select');
            if (select) {
                select.addEventListener('focus', () => select.classList.add('focused'));
                select.addEventListener('blur', () => select.classList.remove('focused'));
            }
        });
    }

    addScrollListener() {
        document.addEventListener('scroll', () => {
            const headerCartBtn = document.querySelector('.product-header-cart_btn');
            const stickyAtc = document.querySelector('.product_sticky_atc_wrap');
            if (headerCartBtn && stickyAtc) {
                const headerCartBtnRect = headerCartBtn.getBoundingClientRect();
                if (headerCartBtnRect.bottom < 0) {
                    stickyAtc.classList.add('open');
                } else {
                    stickyAtc.classList.remove('open');
                    this.hideDropdown();
                }
            }
        });
    }

    initSubscriptionDropdown() {
        if (this.optionButton && this.selectDropdown) {
            this.optionButton.addEventListener('click', (event) => {
                this.toggleDropdown();
                event.stopPropagation();
            });

            document.addEventListener('click', () => {
                this.hideDropdown();
            });

            this.optionButtons.forEach(button => {
                button.addEventListener('click', (event) => {
                    this.replaceOptionContent(button);
                    this.hideDropdown();
                    event.stopPropagation();
                });
            });

            this.selectDropdown.addEventListener('click', (event) => {
                event.stopPropagation();
            });
        }
    }

    toggleDropdown() {
        this.selectDropdown.style.display = this.selectDropdown.style.display === 'block' ? 'none' : 'block';
    }

    hideDropdown() {
        this.selectDropdown.style.display = 'none';
    }

    replaceOptionContent(selectedButton) {
        this.optionButton.innerHTML = selectedButton.innerHTML;
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new StickyBarInteraction();
});



class SubscriptionManager {
  constructor() {
    this.init();
  }

  init() {

    $('.option-button').on('click', (event) => {
      const selectedVal = $(event.currentTarget).data('val');
      this.syncRadioButton(selectedVal);
      this.updateSubscriptionCard(selectedVal);
    });


    $('input[name="subscription"]').on('change', (event) => {
      const selectedSubscription = $(event.currentTarget).val();
      this.updateOptionButtonState(selectedSubscription);
    });


    this.syncVisualState();
  }

  syncRadioButton(selectedVal) {

    const currentChecked = $('input[name="subscription"]:checked').val();
    if (currentChecked !== selectedVal) {

      $('input[name="subscription"][value="' + selectedVal + '"]')
        .prop('checked', true)
        .trigger('change');
    }
  }

  updateOptionButtonState(selectedSubscription) {

    $('.option-button').removeClass('active');
    $('.option-button[data-val="' + selectedSubscription + '"]').click();
    $('.option-button[data-val="' + selectedSubscription + '"]').addClass('active');
  }

  updateSubscriptionCard(selectedVal) {

    $('.subscription_card').removeClass('active_sub');


    $('.subscription_card input[name="subscription"][value="' + selectedVal + '"]')
      .closest('.subscription_card')
      .addClass('active_sub');
  }

  syncVisualState() {

    $('input[name="subscription"]:checked').trigger('change');
  }
}


$(document).ready(() => {
  new SubscriptionManager();
});

